"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TravelBotChatSingleDialogGeneric: ()=>TravelBotChatSingleDialogGeneric
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const format_namespaceObject = require("date-fns/format");
const external_marked_namespaceObject = require("marked");
const react_namespaceObject = require("motion/react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const external_uuid_namespaceObject = require("uuid");
const analytics_js_namespaceObject = require("./analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const VoteDown_js_namespaceObject = require("./Assets/VoteDown.js");
var VoteDown_js_default = /*#__PURE__*/ __webpack_require__.n(VoteDown_js_namespaceObject);
const VoteUp_js_namespaceObject = require("./Assets/VoteUp.js");
var VoteUp_js_default = /*#__PURE__*/ __webpack_require__.n(VoteUp_js_namespaceObject);
const external_chatTypes_js_namespaceObject = require("./chatTypes.js");
const ChatbotDataContext_js_namespaceObject = require("./context/ChatbotDataContext.js");
const external_TravelBotLogoImage_js_namespaceObject = require("./TravelBotLogoImage.js");
const addTargetAttrToHyperLink_js_namespaceObject = require("./utils/addTargetAttrToHyperLink.js");
const feedbackPost_js_namespaceObject = require("./utils/feedbackPost.js");
const sanitizeText_js_namespaceObject = require("./utils/sanitizeText.js");
const COSTUMER_SUPPORT_NUMBER = '1-877-477-5807';
const GREETING_MESSAGE = "Hi, I'm Penny, your virtual travel assistant! How can I help you today?";
const VoteWrapper = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "TravelBotChatSingleDialogGeneric__VoteWrapper"
})([
    "cursor:pointer;"
]);
const CustomChatMessage = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.ChatMessage).withConfig({
    displayName: "TravelBotChatSingleDialogGeneric__CustomChatMessage"
})([
    "overflow-wrap:anywhere;& div:nth-child(2){width:fit-content;}"
]);
const ChatMessageWrapper = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "TravelBotChatSingleDialogGeneric__ChatMessageWrapper"
})([
    "p{margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;margin-bottom:8px;font-size:",
    "px;}p:last-child{margin-bottom:0;}strong{font-weight:bold;}"
], (props)=>props.theme.fontSizes[props.fontSize]);
const TravelBotChatSingleDialogGeneric = (props)=>{
    const { logCustomerCarePhoneNumberClicked, logCustomerCarePhoneNumberDisplayed, isMobile, submitChatMessagesPayload, fetchRequestOptions } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const { message } = props;
    const { rguid, cguid } = submitChatMessagesPayload ?? {};
    const { content, role, vote = external_chatTypes_js_namespaceObject.VoteType.NONE } = message;
    const [voteStatus, setVoteStatus] = (0, external_react_namespaceObject.useState)(vote);
    const [voteSubmitted, setVoteSubmitted] = (0, external_react_namespaceObject.useState)(false);
    const isAssistant = 'assistant' === role;
    const isNotUser = isAssistant;
    function phoneNumberClicked() {
        if (logCustomerCarePhoneNumberClicked && 'function' == typeof logCustomerCarePhoneNumberClicked) logCustomerCarePhoneNumberClicked();
    }
    (0, external_react_namespaceObject.useEffect)(()=>{
        window.phoneNumberClicked = phoneNumberClicked;
        return ()=>{
            window.phoneNumberClicked = null;
        };
    }, []);
    const MessageIcon = function(props) {
        if (isAssistant) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage, {});
        return null;
    };
    const footerMessagePrefix = isAssistant ? 'Penny' : '';
    const transformedDate = message?.date ? new Date(message.date).valueOf() : void 0;
    const footerMessageDateString = transformedDate && 'number' == typeof transformedDate ? (0, format_namespaceObject.format)(message?.date, "LLL d 'at' h:mm:ss aaa") : '';
    const handleVoteStatus = (status)=>{
        setVoteStatus(status);
    };
    const handleFeedbackSubmit = async (vote, feedback)=>{
        const feedbackId = (0, external_uuid_namespaceObject.v4)();
        const pennysid = sessionStorage.getItem('pennysid');
        try {
            if (!voteSubmitted) {
                const { headers } = fetchRequestOptions;
                const baseUrl = '/genai-svc/genai/chat/feedback';
                await (0, feedbackPost_js_namespaceObject.feedbackPost)({
                    feedback: feedback ?? '',
                    message: {
                        ...props.message,
                        vote
                    },
                    conversationId: rguid,
                    feedbackId,
                    cguid,
                    pennysid
                }, baseUrl, headers);
                setVoteSubmitted(true);
            }
        } catch (e) {
            analytics_js_default().log({
                source: 'feedback error',
                message: e,
                cguid,
                feedbackId,
                conversationId: rguid
            });
        }
    };
    const showVoteUp = voteStatus === external_chatTypes_js_namespaceObject.VoteType.NONE || voteStatus === external_chatTypes_js_namespaceObject.VoteType.UP;
    const showVoteDown = voteStatus === external_chatTypes_js_namespaceObject.VoteType.NONE || voteStatus === external_chatTypes_js_namespaceObject.VoteType.DOWN;
    const isGreetingMessage = GREETING_MESSAGE === message.content;
    const voteGap = isMobile ? 4 : 3;
    const Footer = footerMessageDateString ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.div, {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
            alignItems: "center",
            justifyContent: isNotUser ? 'space-between' : 'flex-end',
            children: [
                footerMessagePrefix && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Absolute, {
                    width: 0.96,
                    top: "-10px",
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                        justifyContent: 'space-between',
                        width: 1,
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                                color: "text.light",
                                textStyle: "subheading6",
                                children: [
                                    footerMessagePrefix,
                                    " \xb7 ",
                                    footerMessageDateString
                                ]
                            }),
                            isGreetingMessage ? null : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                children: [
                                    showVoteUp ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(VoteWrapper, {
                                        mr: showVoteUp && !showVoteDown ? 0 : voteGap,
                                        onClick: async function() {
                                            handleVoteStatus(external_chatTypes_js_namespaceObject.VoteType.UP);
                                            await handleFeedbackSubmit(external_chatTypes_js_namespaceObject.VoteType.UP, '');
                                        },
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(VoteUp_js_default(), {
                                            isActive: voteStatus === external_chatTypes_js_namespaceObject.VoteType.UP
                                        })
                                    }) : null,
                                    showVoteDown ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(VoteWrapper, {
                                        onClick: async function() {
                                            handleVoteStatus(external_chatTypes_js_namespaceObject.VoteType.DOWN);
                                            await handleFeedbackSubmit(external_chatTypes_js_namespaceObject.VoteType.DOWN, '');
                                        },
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(VoteDown_js_default(), {
                                            isActive: voteStatus === external_chatTypes_js_namespaceObject.VoteType.DOWN
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    })
                }),
                !footerMessagePrefix && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                    color: "text.light",
                    textStyle: "subheading6",
                    children: footerMessageDateString
                })
            ]
        })
    }) : null;
    function getMarkdownText(text) {
        const rawMarkup = external_marked_namespaceObject.marked.parse((0, sanitizeText_js_namespaceObject.sanitizeText)(text));
        return {
            __html: rawMarkup
        };
    }
    function convertToTelLink(phoneNumber) {
        if (phoneNumber === COSTUMER_SUPPORT_NUMBER && logCustomerCarePhoneNumberDisplayed && 'function' == typeof logCustomerCarePhoneNumberDisplayed) logCustomerCarePhoneNumberDisplayed();
        const cleanNumber = phoneNumber.replace(/\D/g, '');
        return phoneNumber === COSTUMER_SUPPORT_NUMBER ? `<a href="tel:${cleanNumber}" onclick="window.phoneNumberClicked()" >${phoneNumber}</a>` : `<a href="tel:${cleanNumber}">${phoneNumber}</a>`;
    }
    const filterMessage = (content)=>{
        content = content.replace(/\*\*(1?[-.]?\d{3}[-.]?\d{3}[-.]?\d{4})\*\*/g, (_, phoneNumber)=>convertToTelLink(phoneNumber));
        const markdownText = getMarkdownText(content);
        markdownText.__html = (0, addTargetAttrToHyperLink_js_namespaceObject.addTargetAttrToHyperLink)(markdownText.__html);
        return markdownText;
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomChatMessage, {
        "data-testid": isNotUser ? 'pennyCCM' : 'userCCM',
        mb: isNotUser ? '40px' : 4,
        ml: isNotUser ? '' : 'auto',
        variation: isNotUser ? 'initial' : 'outgoing',
        Icon: MessageIcon,
        message: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageWrapper, {
            fontSize: 2,
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                dangerouslySetInnerHTML: filterMessage(content)
            })
        }),
        footer: Footer
    });
};
exports.TravelBotChatSingleDialogGeneric = __webpack_exports__.TravelBotChatSingleDialogGeneric;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TravelBotChatSingleDialogGeneric"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
